export default {
  methods: {
    getProductSources (product) {
      const productProperties = Object.keys(product)
      const sources = []
      productProperties.forEach((property) => {
        sources.push(property.substr(property.indexOf('—') + 2, property.length - 1))
      })
      const uniqueSources = [...new Set(sources)]
      const productSources = []
      uniqueSources.forEach((source) => {
        const productSource = { name: source, properties: [] }
        productProperties.forEach((property) => {
          const sourceName = property.substr(property.indexOf('—') + 2, property.length - 1)
          if (source === sourceName) {
            productSource.properties.push({
              sourceName: source.substr(source.indexOf('—') + 1, source.length),
              propertyName: property,
              propertyLabel: property.substr(0, property.indexOf('—') - 1)
            })
          }
        })
        productSources.push(productSource)
      })
      return productSources
    }
  }
}
